import { render, staticRenderFns } from "./SelectAuthority.vue?vue&type=template&id=57ef57af"
import script from "./SelectAuthority.vue?vue&type=script&lang=js"
export * from "./SelectAuthority.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports